/**
 * Help Video Configuration
 * 
 * This file contains all video URLs used throughout the application for help and tutorial purposes.
 * Each key represents the location/context where the video is displayed.
 * 
 * Video URLs use YouTube embed format. To update a video:
 * 1. Get the YouTube video ID from the URL (e.g., https://www.youtube.com/watch?v=VIDEO_ID)
 * 2. Replace the VIDEO_ID in the corresponding key below
 */

export const helpVideoUrls: Record<string, string> = {
  // Onboarding Step Videos
  'onboarding.step0.overview': 'xJ2mRn4ZDok',         // Replace with actual video ID
  'onboarding.step1.apiDocumentation': 'Bkfy_L79GrA', // Replace with actual video ID
  'onboarding.step2.authorization': '0g3oizqschk',    // Replace with actual video ID
  'onboarding.step3.generationProgress': 'xJ2mRn4ZDok', // Replace with actual video ID
  'onboarding.step4.errorHandling': 'xJ2mRn4ZDok',    // Replace with actual video ID
  'onboarding.step5.toolSelection': 'o-N2sCk1hwE',    // Replace with actual video ID
  'onboarding.step6.success': 'xJ2mRn4ZDok',          // Replace with actual video ID
};

/**
 * Get help video URL by key
 * @param key - The key identifying the video location
 * @returns YouTube video ID or null if not found
 */
export const getHelpVideoUrl = (key: string): string | null => {
  return helpVideoUrls[key] || null;
};
